import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const contactUsSlice = createSlice({
  name: "contactUs",
  initialState: {
    contact: {
      data: [],
      loading: false,
      error: null,
    },

    inquiry: {
      data: [],
      loading: false,
      error: null,
    },
    degree: {
      data: [],
      loading: false,
      error: null,
    },
  },
  reducers: {
    fetchContactStart(state) {
      state.contact.loading = true;
      state.contact.error = false;
    },
    fetchContactSuccess(state, action) {
      state.contact.loading = false;
      state.contact.data = action.payload;
    },
    fetchContactFailure(state, action) {
      state.contact.loading = false;
      state.contact.error = action.payload;
    },
    postInquiryStart(state) {
      state.inquiry.loading = true;
      state.inquiry.erroe = false;
    },
    postInquirySuccess(state, action) {
      state.inquiry.loading = false;
      state.inquiry.data.push(action.payload);
    },
    postInquiryFailure(state, action) {
      state.inquiry.loading = true;
      state.inquiry.error = action.payload;
    },
    fetchDegreeStart(state) {
      state.degree.loading = true;
      state.degree.error = false;
    },
    fetchDegreeSuccess(state, action) {
      state.degree.loading = false;
      state.degree.data = action.payload;
    },
    fetchDegreeFailure(state, action) {
      state.degree.loading = false;
      state.degree.error = action.payload;
    },
  },
});

export const {
  fetchContactStart,
  fetchContactSuccess,
  fetchContactFailure,
  postInquiryStart,
  postInquirySuccess,
  postInquiryFailure,
  fetchDegreeStart,
  fetchDegreeSuccess,
  fetchDegreeFailure,
} = contactUsSlice.actions;

export const fetchContactData = () => async (dispatch) => {
  dispatch(fetchContactStart());
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/ContactUS/getContact`
    );
    const data = response.data.data || []; // Defaults to empty array if no data
    dispatch(fetchContactSuccess(data));
  } catch (error) {
    dispatch(fetchContactFailure(error.message || "Something went wrong"));
  }
};
export const postInquiryData = (inquiryData) => async (dispatch) => {
  dispatch(postInquiryStart()); // Start the process
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/ContactUS/addInquiry`,
      inquiryData
    );

    if (response.status === 200 || response.status === 201) {
      dispatch(postInquirySuccess(response.data)); // Dispatch success action
      return { success: true, message: "Thank you! Your inquiry has been successfully submitted. Our team will contact you shortly" }; // Return success response
    }

    throw new Error(response.data?.message || "Failed to submit inquiry.");
  } catch (error) {
    dispatch(postInquiryFailure(error.message || "Something went wrong")); // Dispatch failure action
    return { success: false, message: error.message || "Something went wrong" }; // Return error response
  }
};



export const fetchDegreeData = () => async (dispatch) => {
  dispatch(fetchDegreeStart());
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/academicPage/getDegreeNames`
    );
    const data = response.data.data || []; // Defaults to empty array if no data
    dispatch(fetchDegreeSuccess(data));
  } catch (error) {
    dispatch(fetchDegreeFailure(error.message || "Something went wrong"));
  }
};

export default contactUsSlice.reducer;
